var _excluded = ["allOf"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cloneDeep = require('lodash/cloneDeep');

var compare = require('json-schema-compare');

var computeLcm = require('compute-lcm');

var defaultsDeep = require('lodash/defaultsDeep');

var flatten = require('lodash/flatten');

var flattenDeep = require('lodash/flattenDeep');

var intersection = require('lodash/intersection');

var intersectionWith = require('lodash/intersectionWith');

var isEqual = require('lodash/isEqual');

var isPlainObject = require('lodash/isPlainObject');

var pullAll = require('lodash/pullAll');

var sortBy = require('lodash/sortBy');

var uniq = require('lodash/uniq');

var uniqWith = require('lodash/uniqWith');

var propertiesResolver = require("./complex-resolvers/properties");

var itemsResolver = require("./complex-resolvers/items");

var contains = function contains(arr, val) {
  return arr.indexOf(val) !== -1;
};

var isSchema = function isSchema(val) {
  return isPlainObject(val) || val === true || val === false;
};

var isFalse = function isFalse(val) {
  return val === false;
};

var isTrue = function isTrue(val) {
  return val === true;
};

var schemaResolver = function schemaResolver(compacted, key, mergeSchemas) {
  return mergeSchemas(compacted);
};

var stringArray = function stringArray(values) {
  return sortBy(uniq(flattenDeep(values)));
};

var notUndefined = function notUndefined(val) {
  return val !== undefined;
};

var allUniqueKeys = function allUniqueKeys(arr) {
  return uniq(flattenDeep(arr.map(keys)));
}; // resolvers


var first = function first(compacted) {
  return compacted[0];
};

var required = function required(compacted) {
  return stringArray(compacted);
};

var maximumValue = function maximumValue(compacted) {
  return Math.max.apply(Math, compacted);
};

var minimumValue = function minimumValue(compacted) {
  return Math.min.apply(Math, compacted);
};

var uniqueItems = function uniqueItems(compacted) {
  return compacted.some(isTrue);
};

var examples = function examples(compacted) {
  return uniqWith(flatten(compacted), isEqual);
};

function compareProp(key) {
  return function (a, b) {
    return compare(_defineProperty({}, key, a), _defineProperty({}, key, b));
  };
}

function getAllOf(schema) {
  var _schema$allOf = schema.allOf,
      allOf = _schema$allOf === void 0 ? [] : _schema$allOf,
      copy = _objectWithoutProperties(schema, _excluded);

  copy = isPlainObject(schema) ? copy : schema; // if schema is boolean

  return [copy].concat(_toConsumableArray(allOf.map(getAllOf)));
}

function getValues(schemas, key) {
  return schemas.map(function (schema) {
    return schema && schema[key];
  });
}

function tryMergeSchemaGroups(schemaGroups, mergeSchemas) {
  return schemaGroups.map(function (schemas, index) {
    try {
      return mergeSchemas(schemas, index);
    } catch (e) {
      return undefined;
    }
  }).filter(notUndefined);
}

function keys(obj) {
  if (isPlainObject(obj) || Array.isArray(obj)) {
    return Object.keys(obj);
  } else {
    return [];
  }
}

function getAnyOfCombinations(arrOfArrays, combinations) {
  combinations = combinations || [];

  if (!arrOfArrays.length) {
    return combinations;
  }

  var values = arrOfArrays.slice(0).shift();
  var rest = arrOfArrays.slice(1);

  if (combinations.length) {
    return getAnyOfCombinations(rest, flatten(combinations.map(function (combination) {
      return values.map(function (item) {
        return [item].concat(combination);
      });
    })));
  }

  return getAnyOfCombinations(rest, values.map(function (item) {
    return item;
  }));
}

function throwIncompatible(values, paths) {
  var asJSON;

  try {
    asJSON = values.map(function (val) {
      return JSON.stringify(val, null, 2);
    }).join('\n');
  } catch (variable) {
    asJSON = values.join(', ');
  }

  throw new Error('Could not resolve values for path:"' + paths.join('.') + '". They are probably incompatible. Values: \n' + asJSON);
}

function callGroupResolver(complexKeywords, resolverName, schemas, mergeSchemas, options, parents) {
  if (complexKeywords.length) {
    var resolverConfig = options.complexResolvers[resolverName];

    if (!resolverConfig || !resolverConfig.resolver) {
      throw new Error('No resolver found for ' + resolverName);
    } // extract all keywords from all the schemas that have one or more
    // then remove all undefined ones and not unique


    var extractedKeywordsOnly = schemas.map(function (schema) {
      return complexKeywords.reduce(function (all, key) {
        if (schema[key] !== undefined) all[key] = schema[key];
        return all;
      }, {});
    });
    var unique = uniqWith(extractedKeywordsOnly, compare); // create mergers that automatically add the path of the keyword for use in the complex resolver

    var mergers = resolverConfig.keywords.reduce(function (all, key) {
      return _objectSpread(_objectSpread({}, all), {}, _defineProperty({}, key, function (schemas) {
        var extraKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return mergeSchemas(schemas, null, parents.concat(key, extraKey));
      }));
    }, {});
    var result = resolverConfig.resolver(unique, parents.concat(resolverName), mergers, options);

    if (!isPlainObject(result)) {
      throwIncompatible(unique, parents.concat(resolverName));
    }

    return result;
  }
}

function createRequiredMetaArray(arr) {
  return {
    required: arr
  };
}

var schemaGroupProps = ['properties', 'patternProperties', 'definitions', 'dependencies'];
var schemaArrays = ['anyOf', 'oneOf'];
var schemaProps = ['additionalProperties', 'additionalItems', 'contains', 'propertyNames', 'not', 'items'];
var defaultResolvers = {
  type: function type(compacted) {
    if (compacted.some(Array.isArray)) {
      var normalized = compacted.map(function (val) {
        return Array.isArray(val) ? val : [val];
      });
      var common = intersection.apply(null, normalized);

      if (common.length === 1) {
        return common[0];
      } else if (common.length > 1) {
        return uniq(common);
      }
    }
  },
  dependencies: function dependencies(compacted, paths, mergeSchemas) {
    var allChildren = allUniqueKeys(compacted);
    return allChildren.reduce(function (all, childKey) {
      var childSchemas = getValues(compacted, childKey);
      var innerCompacted = uniqWith(childSchemas.filter(notUndefined), isEqual); // to support dependencies

      var innerArrays = innerCompacted.filter(Array.isArray);

      if (innerArrays.length) {
        if (innerArrays.length === innerCompacted.length) {
          all[childKey] = stringArray(innerCompacted);
        } else {
          var innerSchemas = innerCompacted.filter(isSchema);
          var arrayMetaScheams = innerArrays.map(createRequiredMetaArray);
          all[childKey] = mergeSchemas(innerSchemas.concat(arrayMetaScheams), childKey);
        }

        return all;
      }

      innerCompacted = uniqWith(innerCompacted, compare);
      all[childKey] = mergeSchemas(innerCompacted, childKey);
      return all;
    }, {});
  },
  oneOf: function oneOf(compacted, paths, mergeSchemas) {
    var combinations = getAnyOfCombinations(cloneDeep(compacted));
    var result = tryMergeSchemaGroups(combinations, mergeSchemas);
    var unique = uniqWith(result, compare);

    if (unique.length) {
      return unique;
    }
  },
  not: function not(compacted) {
    return {
      anyOf: compacted
    };
  },
  pattern: function pattern(compacted) {
    return compacted.map(function (r) {
      return '(?=' + r + ')';
    }).join('');
  },
  multipleOf: function multipleOf(compacted) {
    var integers = compacted.slice(0);
    var factor = 1;

    while (integers.some(function (n) {
      return !Number.isInteger(n);
    })) {
      integers = integers.map(function (n) {
        return n * 10;
      });
      factor = factor * 10;
    }

    return computeLcm(integers) / factor;
  },
  enum: function _enum(compacted) {
    var enums = intersectionWith.apply(null, compacted.concat(isEqual));

    if (enums.length) {
      return sortBy(enums);
    }
  }
};
defaultResolvers.$id = first;
defaultResolvers.$ref = first;
defaultResolvers.$schema = first;
defaultResolvers.additionalItems = schemaResolver;
defaultResolvers.additionalProperties = schemaResolver;
defaultResolvers.anyOf = defaultResolvers.oneOf;
defaultResolvers.contains = schemaResolver;
defaultResolvers.default = first;
defaultResolvers.definitions = defaultResolvers.dependencies;
defaultResolvers.description = first;
defaultResolvers.examples = examples;
defaultResolvers.exclusiveMaximum = minimumValue;
defaultResolvers.exclusiveMinimum = maximumValue;
defaultResolvers.items = itemsResolver;
defaultResolvers.maximum = minimumValue;
defaultResolvers.maxItems = minimumValue;
defaultResolvers.maxLength = minimumValue;
defaultResolvers.maxProperties = minimumValue;
defaultResolvers.minimum = maximumValue;
defaultResolvers.minItems = maximumValue;
defaultResolvers.minLength = maximumValue;
defaultResolvers.minProperties = maximumValue;
defaultResolvers.properties = propertiesResolver;
defaultResolvers.propertyNames = schemaResolver;
defaultResolvers.required = required;
defaultResolvers.title = first;
defaultResolvers.uniqueItems = uniqueItems;
var defaultComplexResolvers = {
  properties: propertiesResolver,
  items: itemsResolver
};

function merger(rootSchema, options, totalSchemas) {
  totalSchemas = totalSchemas || [];
  options = defaultsDeep(options, {
    ignoreAdditionalProperties: false,
    resolvers: defaultResolvers,
    complexResolvers: defaultComplexResolvers,
    deep: true
  });
  var complexResolvers = Object.entries(options.complexResolvers);

  function mergeSchemas(schemas, base, parents) {
    schemas = cloneDeep(schemas.filter(notUndefined));
    parents = parents || [];
    var merged = isPlainObject(base) ? base : {}; // return undefined, an empty schema

    if (!schemas.length) {
      return;
    }

    if (schemas.some(isFalse)) {
      return false;
    }

    if (schemas.every(isTrue)) {
      return true;
    } // there are no false and we don't need the true ones as they accept everything


    schemas = schemas.filter(isPlainObject);
    var allKeys = allUniqueKeys(schemas);

    if (options.deep && contains(allKeys, 'allOf')) {
      return merger({
        allOf: schemas
      }, options, totalSchemas);
    }

    var complexKeysArr = complexResolvers.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          mainKeyWord = _ref2[0],
          resolverConf = _ref2[1];

      return allKeys.filter(function (k) {
        return resolverConf.keywords.includes(k);
      });
    }); // remove all complex keys before simple resolvers

    complexKeysArr.forEach(function (keys) {
      return pullAll(allKeys, keys);
    }); // call all simple resolvers for relevant keywords

    allKeys.forEach(function (key) {
      var values = getValues(schemas, key);
      var compacted = uniqWith(values.filter(notUndefined), compareProp(key)); // arrayprops like anyOf and oneOf must be merged first, as they contains schemas
      // allOf is treated differently alltogether

      if (compacted.length === 1 && contains(schemaArrays, key)) {
        merged[key] = compacted[0].map(function (schema) {
          return mergeSchemas([schema], schema);
        }); // prop groups must always be resolved
      } else if (compacted.length === 1 && !contains(schemaGroupProps, key) && !contains(schemaProps, key)) {
        merged[key] = compacted[0];
      } else {
        var resolver = options.resolvers[key] || options.resolvers.defaultResolver;
        if (!resolver) throw new Error('No resolver found for key ' + key + '. You can provide a resolver for this keyword in the options, or provide a default resolver.');

        var _merger = function _merger(schemas) {
          var extraKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          return mergeSchemas(schemas, null, parents.concat(key, extraKey));
        };

        merged[key] = resolver(compacted, parents.concat(key), _merger, options);

        if (merged[key] === undefined) {
          throwIncompatible(compacted, parents.concat(key));
        } else if (merged[key] === undefined) {
          delete merged[key];
        }
      }
    });
    return complexResolvers.reduce(function (all, _ref3, index) {
      var _ref4 = _slicedToArray(_ref3, 2),
          resolverKeyword = _ref4[0],
          config = _ref4[1];

      return _objectSpread(_objectSpread({}, all), callGroupResolver(complexKeysArr[index], resolverKeyword, schemas, mergeSchemas, options, parents));
    }, merged);
  }

  var allSchemas = flattenDeep(getAllOf(rootSchema));
  var merged = mergeSchemas(allSchemas);
  return merged;
}

merger.options = {
  resolvers: defaultResolvers
};
module.exports = merger;